// extracted by mini-css-extract-plugin
module.exports = {"descriptionTerm":"DescriptionTerm_descriptionTerm__ip52l bodyS"};